import { render, staticRenderFns } from "./chat-list.vue?vue&type=template&id=2d694524&"
import script from "./chat-list.vue?vue&type=script&lang=js&"
export * from "./chat-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports